import React, { useContext, useEffect } from "react";
import { LanguageContext } from "./Contexts/LanguageContext/LanguageContext";
import { NavbarSection } from "./Components/Navbar";
import { ThemeProvider } from "react-bootstrap";
import { HeadingSecion } from "./Components/Heading";
import { LookingForSection } from "./Components/LookingForSection";
import { AboutUs } from "./Components/AboutUs";
// import { PartnersSection } from "./Components/Partners";
import { CustomersSection } from "./Components/Customers";
import { ContactsSection } from "./Components/Contacts";

function App() {
  const {lang, editLang} = useContext(LanguageContext);
  
  useEffect(() => {
    const urlParamsObject = new URLSearchParams(window.location.search);
    editLang(urlParamsObject.get("lang")?.toLowerCase() ?? "ru");
    // eslint-disable-next-line
  }, []);

  return (
    <ThemeProvider>
      <NavbarSection lang={lang} />
      <HeadingSecion lang={lang} />
      {/*<LookingForSection lang={lang} />*/}
      <AboutUs lang={lang} />
      {/*<PartnersSection lang={lang} />*/}
      <CustomersSection lang={lang} />
      <ContactsSection lang={lang} />
    </ThemeProvider>
  );
}

export default App;
